/* eslint-disable no-nested-ternary */
import React, { useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import { Field, Button, Translate } from 'components';
import './style.scss';

function LoginForm({ onFormSubmit = () => {} }) {
  const {
    formState: { errors },
    control,
    handleSubmit,
  } = useForm();
  const onSubmit = data => onFormSubmit(data);

  useEffect(() => {
    document.title = `Logga in - TFV Tolkportal`;
  }, []);

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="tv-login-form__container"
    >
      <div className="tv-login-form__header">Logga in</div>
      <Controller
        control={control}
        render={({ field: { onChange, onBlur, value } }) => (
          <Field
            type="text"
            aria-label={Translate({ content: 'general.email' })}
            onChange={onChange}
            onBlur={onBlur}
            name="email"
            value={value}
            placeholder={Translate({ content: 'general.email' })}
            label={Translate({ content: 'general.email' })}
            autoFocus
            error={
              errors.email
                ? errors?.email?.type === 'required'
                  ? Translate({
                      content: 'validator.isRequired',
                      params: { name: Translate({ content: 'general.email' }) },
                    })
                  : errors.email.message
                : null
            }
          />
        )}
        type="email"
        name="email"
        rules={{
          required: true,
          pattern: {
            value: /^[^\s@]+@[^\s@]+$/,
            message: Translate({
              content: 'validator.isNotValid',
              params: { name: Translate({ content: 'general.email' }) },
            }),
          },
        }}
      />
      <Controller
        control={control}
        render={({ field: { onChange, onBlur, value } }) => (
          <Field
            onChange={onChange}
            name="password"
            type="password"
            aria-label={Translate({ content: 'general.password' })}
            onBlur={onBlur}
            value={value}
            placeholder={Translate({ content: 'login.enterYourPassword' })}
            label={Translate({ content: 'general.password' })}
            error={
              errors.password
                ? errors?.password?.type === 'required'
                  ? Translate({
                      content: 'validator.isRequired',
                      params: {
                        name: Translate({ content: 'general.password' }),
                      },
                    })
                  : errors.password.message
                : null
            }
            yarns
          />
        )}
        type="text"
        name="password"
        rules={{
          required: true,
          pattern: {
            value: /^.{8,}$/,
            message: Translate({
              content: 'validator.isNotValid',
              params: {
                name: Translate({ content: 'general.password' }),
              },
            }),
          },
        }}
      />
      <Button type="submit" label="Logga in" />
    </form>
  );
}

LoginForm.propTypes = {
  onFormSubmit: PropTypes.func,
};

export default LoginForm;
